import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimg from "../../../assets/appDevLeftImg.png";
import rightimg from "../../../assets/appDevRightImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import appDevBenefitsImg1 from "../../../assets/appDevBenefitsImg1.png";
import appDevBenefitsImg2 from "../../../assets/appDevBenefitsImg2.png";
import appDevBenefitsImg3 from "../../../assets/appDevBenefitsImg3.png";
import appDevBenefitsImg4 from "../../../assets/appDevBenefitsImg4.png";
import appDevBenefitsImg5 from "../../../assets/appDevBenefitsImg5.png";
import appDevBenefitsImg6 from "../../../assets/appDevBenefitsImg6.png";
import appDevBenefitsImg7 from "../../../assets/appDevBenefitsImg7.png";
import appDevBenefitsImg8 from "../../../assets/appDevBenefitsImg8.png";
import appDevBenefitsImg9 from "../../../assets/appDevBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
import appDevFunActivitiesImg1 from "../../../assets/appDevFunActivitiesImg1.png";
import appDevFunActivitiesImg2 from "../../../assets/appDevFunActivitiesImg2.png";
import appDevFunActivitiesImg3 from "../../../assets/appDevFunActivitiesImg3.png";
import appDevFunActivitiesImg4 from "../../../assets/appDevFunActivitiesImg4.png";
import appDevFunActivitiesImg5 from "../../../assets/appDevFunActivitiesImg5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";

const AndroidAppDevPortal = () => {
  const appdevpage = heroContent.androidappdevpage;

  const beginnerModules = [
    {
      title: "Module 1",
      activities: "10",
      classes: "5",
      description:
        "OOP Concepts Master Java basics, classes, inheritance & exceptions.",
    },
    {
      title: "Module 2",
      activities: "10",
      classes: "5",
      description:
        "Android App Build simple apps with Activities, Views & Layouts.",
    },
    {
      title: "Module 3",
      activities: "6",
      classes: "3",
      description:
        "User Interaction Add inputs, navigation, dialogs & gestures.",
    },
    {
      title: "Module 4",
      activities: "6",
      classes: "3",
      description:
        "Delightful UI Design stylish UIs with themes, motion & testing.",
    },
    {
      title: "Module 5",
      activities: "6",
      classes: "3",
      description: "Services Add internet, alarms & background tasks.",
    },
    {
      title: "Module 6",
      activities: "10",
      classes: "5",
      description: "Firebase Create real apps with login, database & storage.",
    },
  ];

  const benefitsData = [
    {
      title: "Master OOP Concepts",
      description: "Learn Classes, Objects, Inheritance, and Polymorphism.",
      icon: appDevBenefitsImg1,
    },
    {
      title: "Boost Code Efficiency",
      description: "Use Inheritance and Polymorphism for maintainable code.",
      icon: appDevBenefitsImg2,
    },
    {
      title: "Build Robust Apps",
      description: "Implement Exception Handling for error-free apps.",
      icon: appDevBenefitsImg3,
    },
    {
      title: "Design Interactive UI",
      description: "Master Views, Layouts, and Resources for responsive UI.",
      icon: appDevBenefitsImg4,
    },
    {
      title: "Seamless Navigation",
      description: "Manage Activities and Intents for smooth app flow.",
      icon: appDevBenefitsImg5,
    },
    {
      title: "Advanced User Interaction",
      description: "Use Recycler Views, Dialogs, and Gestures.",
      icon: appDevBenefitsImg6,
    },
    {
      title: "Integrate Firebase",
      description: "Manage data with Firebase for real-time apps.",
      icon: appDevBenefitsImg7,
    },
    {
      title: "Test for Quality",
      description:
        "Ensure reliable, bug-free app experiences through effective testing.",
      icon: appDevBenefitsImg8,
    },
    {
      title: "Master Background Tasks",
      description:
        "Use Job Scheduler and Alarm Manager for seamless app performance.",
      icon: appDevBenefitsImg9,
    },
  ];
  const activitiesData = [
    {
      title: "Scrolling Text App",
      image: appDevFunActivitiesImg1,
    },
    {
      title: "Counter App",
      image: appDevFunActivitiesImg2,
    },
    {
      title: "Food Ordering App",
      image: appDevFunActivitiesImg3,
    },
    {
      title: "Alarm Manager",
      image: appDevFunActivitiesImg4,
    },
    {
      title: "Dictionary App",
      image: appDevFunActivitiesImg5,
    },
  ];

  return (
    <>
      <GuestNav />
      <Hero2
        titlePart1={appdevpage.titlePart1}
        description={appdevpage.description}
        buttonText={appdevpage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        modules={beginnerModules}
      />
      <Benefits
        title="How Students Can Benefit From Android App Develpment"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn App Development"
        subTitle="With 30+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default AndroidAppDevPortal;
